import React, { Component, lazy } from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import { connect } from 'react-redux'
import { ROUTE_PATH } from "../utils/Global"

import TopBarV2 from "@/_CustomPages/Cafe24/TopBarV2"
import MakeVideo from "@/Routers/MakeVideo"
// import Navigator from "@/_CustomPages/Cafe24/Navigator"
import ChatPage from "@/Routers/ChatPage"
import DataManager from "@/utils/DataManager"
import { Logout } from "@/Interface"
import Footer from "@/_CustomPages/Cafe24/Footer"
import TwoBtnDialog from "@/Common/TwoButtonDialog"
import { PaymentsApis } from '@/utils/Videomonster/Apis'
import { ErrorHandler } from '@/utils/Error/Handler'
import i18n from '@/i18n';
import { SetLanguage } from '@/utils/LangHelper'
// import AiTools from "../Routers/AiTools"
import ShortsCustomizing from "../Routers/ShortsCustomizing"
// 무료 기간 알림 팝업 > 요금제 바로가기 버튼 클릭 >  lazyLoad로 import 하면 페이지가 나오지 않기 때문에 수정
import Payment from "@/_CustomPages/Cafe24/Payment/v2/Payment"
import Validator from "@/utils/Validator"
const Home = lazy(() => import('@/_CustomPages/Cafe24/home'))
// const DesignSelect = lazy(() => import('@/Routers/designSelect'));
// const UserPage = lazy(() => import("@/Routers/UserPage"))
const Login = lazy(() => import("@/_CustomPages/Cafe24/Login/Login"))
const RequiredBox = lazy(() => import("@/_CustomPages/Cafe24/RequiredBox/RequiredBox"))
const Tos = lazy(() => import('@/Footer/TOS'))
const Privacy = lazy(() => import('@/Footer/Privacy'))
const Copyright = lazy(() => import('@/Footer/Copyright'))
const AiTerm = lazy(() => import('@/Footer/AiTerm'))

const StudioRootContainer = lazy(() => import('../Studio'))
const MyPageRootContainer = lazy(() => import('../MyPage'))

function objectNullCheck(obj) {
  obj = JSON.stringify(obj);
  if (!obj || obj === "null" || obj === "{}") return false;
  return true
}
class Cafe24 extends Component {
  state = {
    isInvalidSession: false,
    isOpenExpiredDialog: false,
  }
  
  listenLocationChange = (props) => { this.props.listenLocationChange(props) }

  componentDidMount = async () => {
    const cfAccessToken = await DataManager.GetCafe24AccessToken();
    const vmRefreshToken = DataManager.GetRefreshToken();
    const pathname = this.props.history.location.pathname
    if (!vmRefreshToken && !cfAccessToken) {
      if (pathname !== "/" && pathname !== "/home" && pathname !== "/login") this.props.history.push("/login");
      this.setState({ isInvalidSession: true })
    }
    SetLanguage('ko')
  }

  componentDidUpdate = (prevProps) => {
    const { currentUser, payments } = this.props
    if ((this.props.location.pathname !== prevProps.location.pathname) &&
      this.props.location.pathname !== "/login" &&
      this.props.location.pathname !== "/" &&
      this.props.location.pathname !== "/home") {
      this.checkSession()
    }
    //비몬 계정으로 cafe24 접근시 다시 비몬으로 redirect
    if ((prevProps.currentUser !== currentUser) && objectNullCheck(currentUser) && currentUser.type !== "cafe24") {
      DataManager.ClearProvider();
      this.props.history.replace("/")
    }

    if ((prevProps.payments !== payments) && payments.length <= 0) {
      this.setIsOpenExpiredDialog()
    }
  }

  checkSession = async () => {
    const cfAccessToken = await DataManager.GetCafe24AccessToken();
    const vmRefreshToken = DataManager.GetRefreshToken();
    if ((!vmRefreshToken || !cfAccessToken) && !this.state.isInvalidSession) {
      Logout()
      this.setState({ isInvalidSession: true });
    } else if (vmRefreshToken && cfAccessToken && this.state.isInvalidSession) {
      this.setState({ isInvalidSession: false });
    }
  }

  setIsOpenExpiredDialog = async () => {
    try {
      const token = DataManager.GetToken()
      const { data: cafe24FreeTicket } = await PaymentsApis.GetFreeTickets(token, { productId: '6324403ec2cb943c903d366f' })

      if (!cafe24FreeTicket || !Validator.ArrayNotEmpty(cafe24FreeTicket.list)) return

      const cafe24FreeTicketInfo = cafe24FreeTicket.list[0]
      const expiredAt = new Date(cafe24FreeTicketInfo.expiredAt)
      const currentDate = new Date()

      if (!cafe24FreeTicketInfo.notifyConfirmedAt && expiredAt < currentDate) {
        await PaymentsApis.PatchNotifyConfirm(token, { paymentId: cafe24FreeTicketInfo._id })
        this.setState({ isOpenExpiredDialog: true })
      }
    }
    catch (e) {
      ErrorHandler(this, null, e, { alert: true, log: false, server: false })
    }
  }

  handleCloseExpiredDialog = () => this.setState({ isOpenExpiredDialog: false })

  handleClickExpiredDialogRightBtn = () => {
    this.handleCloseExpiredDialog()
    this.props.history.push('/payment')
  }

  renderLogin = () => {
    const { isMobile } = this.props
    return (
      <>
        <TopBarV2 minWidth={1426 - 40} {...this.props} />
        <Switch>
          <Route
            exact
            path="/"
            component={props => {
              this.listenLocationChange(props)
              return <Home
                {...props}
                isMobile={isMobile}
              />
            }}
          />
          <Route
            exact
            path="/home"
            component={props => {
              this.listenLocationChange(props)
              return <Home
                {...props}
                isMobile={isMobile}
              />
            }}
          />
          <Route
            exact
            path="/login"
            component={props => {
              this.listenLocationChange(props)
              return <Login
                {...props}
                isMobile={isMobile}
              />
            }}
          />
          <Route
            path="/Tos"
            component={props => {
              this.listenLocationChange(props)
              return <Tos {...props} />
            }}
          />
          <Route
            path="/Privacy"
            component={props => {
              this.listenLocationChange(props)
              return <Privacy {...props} />
            }}
          />

          <Route
            path="/Copyright"
            component={props => {
              this.listenLocationChange(props)
              return <Copyright {...props} />
            }}
          />
          <Route
            path="/ai-product-term"
            component={props => {
              this.listenLocationChange(props)
              return <AiTerm {...props} />
            }}
          />
          <Route
            component={props => {
              this.listenLocationChange(props)
              return <Home
                {...props}
                isMobile={isMobile}
              />
            }}
          />

        </Switch>
        <Footer {...this.props} />
      </>
    )
  }
  renderCafe24 = () => {
    const { isMobile } = this.props
    const { pathname } = window.location
    const pathnameArray = pathname.split('/')

    const firstPath = pathnameArray.length > 1 ? pathnameArray[1] : null
    let showHeader = true;
    let isBlackHeader = false;
    let hideMenuArea = false;
    let showFooter = true;
    switch (firstPath) {
      case 'admin':
      case 'chat':
        showHeader = false;
        showFooter = false;
        break;

      case 'studio':
      case 'shorts-customizing':
      case 'makevideo':
        hideMenuArea = true
        showFooter = false;
        break;

      case 'user':
        showFooter = false;
        break;
    }

    return <>
      {
        showHeader &&
        <>
          <TopBarV2 minWidth={1426 - 40} hideMenuArea={hideMenuArea} {...this.props} black={isBlackHeader} />
        </>
      }
      <Switch>
        <Route
          exact
          path="/"
          component={props => {
            this.listenLocationChange(props)
            return <Home
              {...props}
              isMobile={isMobile}
            />
          }}
        />

        <Route
          path="/home"
          component={props => {
            this.listenLocationChange(props)
            return <Home
              {...props}
              isMobile={isMobile}
            />
          }}
        />
        <Route
          path="/designselect"
          component={props => {
            this.listenLocationChange(props)
            return <Redirect to={ROUTE_PATH.DESIGN_SELECT} />
          }}
        />

        <Route
          path="/user/:id"
          component={props => {
            this.listenLocationChange(props)
            return <MyPageRootContainer {...props} />
          }}
        />

        <Route
          path="/studio"
          component={props => {
            this.listenLocationChange(props)
            return <StudioRootContainer {...props} />
          }}
        />

        <Route
          path="/makevideo"
          component={props => {
            this.listenLocationChange(props)
            return <MakeVideo {...props} />
          }}
        />

        <Route
          path="/aitools"
          component={props => {
            this.listenLocationChange(props)
            return <Redirect to={ROUTE_PATH.AI_TOOLS} />
          }}
        />

        <Route
          path="/shorts-customizing"
          component={props => {
            this.listenLocationChange(props)
            return <ShortsCustomizing {...props} />
          }}
        />

        <Route
          path="/payment"
          component={props => {
            this.listenLocationChange(props)
            return <Payment {...props} />
          }}
        />

        <Route
          path="/login"
          component={props => {
            this.listenLocationChange(props)
            return <Login {...props} />
          }}
        />

        <Route
          path="/requiredBox"
          component={props => {
            this.listenLocationChange(props)
            return <RequiredBox {...props} />
          }}
        />

        <Route path="/chat" component={props => <ChatPage {...props} />} />

        <Route path="/make" component={() => <Redirect to={'/designSelect'} />} />
        <Route path="/myVideo" component={() => <Redirect to={'/user/_/my-video'} />} />
        <Route path="/shop" component={() => <Redirect to={'/payment'} />} />
        <Route
          path="/Tos"
          component={props => {
            this.listenLocationChange(props)
            return <Tos {...props} />
          }}
        />

        <Route
          path="/Privacy"
          component={props => {
            this.listenLocationChange(props)
            return <Privacy {...props} />
          }}
        />

        <Route
          path="/Copyright"
          component={props => {
            this.listenLocationChange(props)
            return <Copyright {...props} />
          }}
        />
        <Route
          path="/ai-product-term"
          component={props => {
            this.listenLocationChange(props)
            return <AiTerm {...props} />
          }}
        />
        <Route component={() => <Redirect to={'/'} />} />

      </Switch>
      {
        showFooter && <Footer {...this.props} />
      }
    </>
  }

  render() {
    const { isOpenExpiredDialog } = this.state
    const { currentUser } = this.props

    // 유저 정보를 가지고 오고있는 상태
    if (typeof currentUser === 'object' && Object.keys(currentUser).length === 0) {
      return this.renderCafe24()
    }

    if (currentUser && !currentUser.agreement) return (
      <>
        <TopBarV2 {...this.props} />
        <RequiredBox {...this.props} />
      </>
    )

    return (
      <>
        {
          (this.state.isInvalidSession)
            ? this.renderLogin()
            : this.renderCafe24()
        }
        <TwoBtnDialog
          title={i18n.t("Cafe24.expiredpopup.title")}
          body={i18n.t("Cafe24.expiredpopup.body")}
          open={isOpenExpiredDialog}
          onClose={this.handleCloseExpiredDialog}
          handleClickBtn1={this.handleCloseExpiredDialog}
          handleClickBtn2={this.handleClickExpiredDialogRightBtn}
          btn1String={i18n.t("Cafe24.expiredpopup.left.button")}
          btn2String={i18n.t("Cafe24.expiredpopup.right.button")}
          clsssOfBtn2="black"
        />
      </>
    )
  }
}

const mapStateToProps = state => ({
  currentUser: state.userStore.user,
  payments: state.paymentsStore.payments,
})

export default connect(
  mapStateToProps,
  null
)(Cafe24);